<template>
  <div id="myDateShow">
    <div class="title">查看 微视频资料</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">微视频名称</div>
        <div class="value">{{video.title}}</div>
      </div>
      <div class="line">
        <div class="key">视频制作人/农基商</div>
        <div class="value">{{video.merchants.merchantsName}}</div>
      </div>
      <div class="line">
        <div class="key">微视频类型</div>
        <div class="value">{{video.pmsVideoClassify.classifyName}}</div>
      </div>
      <div class="line">
        <div class="key">微视频描述</div>
        <div class="value">{{video.videoDetail}}</div>
      </div>
      <div class="line">
        <div class="key">是否需要被推荐</div>
        <div class="value">{{video.isRecommend=="0"?"推荐":"不推荐"}}</div>
      </div>
      <div class="line">
        <div class="key">是否上线</div>
        <div class="value">{{video.isOnline=="0"?"上线":"未上线"}}</div>
      </div>
      <div class="line">
        <div class="key">视频封面图</div>
        <div class="value">
          <img class="skuImg" v-if="video.defaultImg" :src="video.defaultImg" alt="">
        </div>
      </div>
      <div class="line">
        <div class="key">上传时间</div>
        <div class="value">{{video.uploadTime}}</div>
      </div>
      <div class="line"></div>

    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getVideoById,newVue} from "../../network/video";

  export default {
    name: "VideoData",
    components: {},
    data(){
      return{
        videoId:"",
        video:{}
      }
    },
    methods:{
      aaa(){},
      backClick(){
        this.$router.push("../list");
      },
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/video/list";
      this.common.HeaderLocationTwo.name =  "微视频管理"
      this.common.HeaderLocationThree.name = "微视频详情"
      console.log(this.$route.params.id);
      this.videoId = this.$route.params.id;

      getVideoById(this.videoId).then(res => {
        this.video = res.data
      })
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
</style>
